var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvitation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m269.36 325.645c-7.704-6.547-19.017-6.547-26.721 0l-212.71 180.781c3.687 3.448 8.626 5.574 14.072 5.574h423.998c5.446 0 10.385-2.126 14.072-5.574z",
    fill: "#ffdc00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.519 345.327 189.553 161.099c4.027-3.765 6.558-9.109 6.558-15.057v-282.283z",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.929 506.426 189.552-161.099-196.11-136.241v282.284c0 5.947 2.531 11.291 6.558 15.056z",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.929 506.426 189.552-161.099-12.01-8.344-184 156.381c.496 5.142 2.887 9.723 6.458 13.062z",
    fill: "#fbbd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.071 506.426-189.552-161.099 12.01-8.344 184 156.381c-.497 5.142-2.887 9.723-6.458 13.062z",
    fill: "#fbbd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.952 159.298v90.486l-58.581-40.698z",
    fill: "#ff7e00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.371 209.086 58.581 40.698v-18.568l-46.561-32.346z",
    fill: "#ff6700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.048 159.298v90.486l58.581-40.698z",
    fill: "#ff7e00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.047 231.216v18.568l58.582-40.698-12.021-10.216z",
    fill: "#ff6700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.481 345.327 23.158-19.682c7.704-6.547 19.017-6.547 26.721 0l23.159 19.682 137.529-95.543v-244.633c0-2.845-2.306-5.151-5.151-5.151h-337.794c-2.845 0-5.151 2.306-5.151 5.151v244.632z",
    fill: "#fff0c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.519 326.76-23.159-19.682c-7.704-6.547-19.017-6.547-26.721 0l-23.159 19.682-137.528-95.544v18.567l137.529 95.543 23.159-19.682c7.704-6.547 19.017-6.547 26.721 0l23.159 19.682 137.529-95.543v-18.567z",
    fill: "#ffe394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.996 84.075 17.062 28.765c1.958 3.302 5.191 5.65 8.936 6.493l32.63 7.338c10.334 2.324 14.408 14.864 7.414 22.818l-22.085 25.116c-2.535 2.883-3.77 6.683-3.413 10.505l3.105 33.3c.983 10.546-9.684 18.297-19.41 14.103l-30.711-13.243c-3.525-1.52-7.521-1.52-11.046 0l-30.711 13.243c-9.726 4.194-20.394-3.556-19.41-14.103l3.105-33.3c.356-3.822-.878-7.622-3.413-10.505l-22.085-25.116c-6.994-7.954-2.919-20.494 7.414-22.818l32.63-7.338c3.745-.842 6.978-3.191 8.936-6.493l17.062-28.765c5.401-9.11 18.587-9.11 23.99 0z",
    fill: "#ffdc00"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m310.554 206.715c-2.913 6.661-10.889 10.434-18.32 7.229l-30.711-13.243c-3.525-1.52-7.521-1.52-11.046 0l-30.711 13.243c-7.432 3.204-15.407-.568-18.32-7.229l-1.09 11.694c-.983 10.546 9.684 18.297 19.41 14.103l30.711-13.243c3.525-1.52 7.521-1.52 11.046 0l30.711 13.243c9.726 4.194 20.394-3.556 19.41-14.103z",
    fill: "#ffbf00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitation);
export default __webpack_public_path__ + "static/media/invitation.1155ffb2efcbe99ddb5446f927636a20.svg";
export { ForwardRef as ReactComponent };